const texts = {
    cargando:'Cargando',
  };
  
  export default texts;